import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// 🔹 Async Thunk to Fetch Game Settings
export const fetchGameSettings = createAsyncThunk(
    "gameSettings/fetchGameSettings",
    async ({ gameId, partnerCode, token }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/game/slot/details`, { gameId, partnerCode, token });

            // 🔹 Store in localStorage for persistence
            localStorage.setItem("gameSettings", JSON.stringify(response.data.data));

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// 🔹 Game Settings Slice
const gameSettingsSlice = createSlice({
    name: "gameSettings",
    initialState: {
        data: JSON.parse(localStorage.getItem("gameSettings")) || null,
        loading: false,
        error: null,
    },
    reducers: {
        clearGameSettings: (state) => {
            state.data = null;
            localStorage.removeItem("gameSettings");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGameSettings.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGameSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchGameSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearGameSettings } = gameSettingsSlice.actions;
export default gameSettingsSlice.reducer;
